'use strict';

var App = require('app');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var i18n = require('utils/i18n');

var CopyConfigurationDialogView = Marionette.ItemView.extend({
    template: require('components/devices/templates/common/copy_configuration_dialog'),

    events: {
        'click #js-btn-save': 'save',
        'click .js-copy-toggle': 'toggle',
        'change #js-device-select': 'selectDevice',
    },

    initialize: function (options) {
        this.isGenericModbus = options.device.get('category') == 'GenericModbus';

        this.target_device = options.device;
        this.source_device = undefined;

        this.selection = {
            type_identifier: this.isGenericModbus,
            schema: true,
            sidebar: true,
            data_points: true,
        };
    },

    serializeData: function () {
        return {
            sourceDeviceID: this.source_device,
            hasSelection: this.getSelection().length > 0,
            elements: [
                {
                    id: 'type_identifier',
                    text: i18n.TR('Gerätetyp'),
                    isEnabled: this.selection.type_identifier,
                },
                {
                    id: 'schema',
                    text: i18n.TR('Anlagenschema'),
                    isEnabled: this.selection.schema,
                },
                {
                    id: 'sidebar',
                    text: i18n.TR('Anlagenschema - Einstellungen der Seitenleiste'),
                    isEnabled: this.selection.sidebar,
                },
                {
                    id: 'data_points',
                    text: i18n.TR('Konfigurierte Datenpunkte'),
                    isEnabled: this.selection.data_points,
                },
            ].slice(this.isGenericModbus ? 0 : 1),
        };
    },

    onDomRefresh: function () {
        var self = this;
        Misc.initSelectPicker();
        Misc.initDevicePicker({
            filter: function () {
                return {
                    categories: [self.target_device.get('category')],
                };
            },
        });
    },

    getSelection: function () {
        var result = [];
        _.each(this.selection, function (selected, id) {
            if (selected) {
                result.push(id);
            }
        });
        return result;
    },

    selectDevice: function (e) {
        this.source_device = parseInt($('#js-device-select').val());
        if (this.source_device == this.target_device.get('id')) {
            this.source_device = undefined;
        }
        this.render();
    },

    toggle: function (e) {
        var id = e.currentTarget.id.split('-')[2];
        this.selection[id] = !this.selection[id];
        this.render();
    },

    save: function () {
        App.ajax({
            method: 'POST',
            url: '/api/v1/devices/copy-config',
            contentType: 'application/json',
            data: JSON.stringify({
                source: this.source_device,
                target: this.target_device.get('id'),
                selection: this.getSelection(),
            }),

            success: function (_data) {
                Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Konfiguration wurde kopiert.'));
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
            error: function (_data) {
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Konfiguration konnte nicht kopiert werden.'));
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
        });

        App.hideModal();
    },
});

module.exports = CopyConfigurationDialogView;
